"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientEditPendingResponseSchema = exports.patientEditRequestSchema = exports.patientEditPreviewResponseSchema = exports.patientEditChangeSchema = void 0;
const zod_1 = require("zod");
const financial_correction_stage_response_1 = require("./financial-correction-stage.response");
const financial_payment_correction_request_1 = require("../request/financial-payment-correction.request");
/** One field of the change, as the approver reads it: names, never ids. `from` / `to` are display text ("—" for empty). */
exports.patientEditChangeSchema = zod_1.z.object({
    field: zod_1.z.string(),
    label: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
});
/**
 * THE ANSWER TO "WOULD THIS EDIT BE ALLOWED, AND WHAT WOULD IT DO?" — run before the clerk writes a reason, again when the request is
 * made, and again at verification and approval (a request can wait days; the record is not frozen meanwhile).
 */
exports.patientEditPreviewResponseSchema = zod_1.z.object({
    eligible: zod_1.z.boolean(),
    blockers: zod_1.z.array(zod_1.z.string()),
    patientId: zod_1.z.string().uuid(),
    uhid: zod_1.z.string(),
    patientName: zod_1.z.string(),
    changes: zod_1.z.array(exports.patientEditChangeSchema),
    /** What approving will do: how many bills, lab reports (and how many released) and appointments carry this patient, what is re-stamped, what is unchanged. */
    effects: zod_1.z.array(zod_1.z.string()),
});
exports.patientEditRequestSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    status: financial_payment_correction_request_1.paymentCorrectionStatusEnum,
    patientId: zod_1.z.string().uuid(),
    uhid: zod_1.z.string(),
    patientName: zod_1.z.string(),
    changes: zod_1.z.array(exports.patientEditChangeSchema),
    reason: zod_1.z.string(),
    requestedBy: zod_1.z.string().uuid().nullable(),
    requestedByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string(),
    /** Where the request is in Request -> Verify -> Approve. See `correctionStageEnum`. */
    stage: financial_correction_stage_response_1.correctionStageEnum,
    verifiedBy: zod_1.z.string().uuid().nullable(),
    verifiedByName: zod_1.z.string().nullable(),
    verifiedAt: zod_1.z.string().nullable(),
    verificationNote: zod_1.z.string().nullable(),
    approvedBy: zod_1.z.string().uuid().nullable(),
    approvedByName: zod_1.z.string().nullable(),
    approvedAt: zod_1.z.string().nullable(),
    decisionReason: zod_1.z.string().nullable(),
    appliedSummary: zod_1.z.array(zod_1.z.string()).nullable(),
    /** What approving would do TODAY, for a PENDING request — or why it can no longer be applied. Null once decided. */
    effects: zod_1.z.array(zod_1.z.string()).nullable().optional(),
});
/** "Is an edit already waiting for this patient?" — so the Edit button can say so before a clerk fills the form in. */
exports.patientEditPendingResponseSchema = zod_1.z.object({
    pending: zod_1.z.boolean(),
    requestedByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().nullable(),
});
//# sourceMappingURL=financial-patient-correction.response.js.map